// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // urlApi: 'https://ws.sucovirecupera.com:8443/CoviRecupera/servicios',
  urlApi: 'https://service.covinoc.cloud/CoviRecupera/servicios',
  shopUrl: 'https://sucovirecupera.com/#/pagos',
  urlReturn: 'https://sucovirecupera.com/',
  urlApiPayzen: 'https://service.covinoc.cloud/PayzenCorporativo/servicios',
  urlMicrofrontReportsCharts: 'http://localhost:4201/assets/microfrontend/graficas/',
  app: 'COVIRECUPERA_EXTERNO',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
